<template>
  <div class="sidenav-logo">
    <base-image :src="url" v-if="!customLogo.file_url" />
    <base-image :src="customLogo.file_url" v-else />
  </div>
</template>

<script>
import { STATIC_IMG_PATH } from "Consts/static";
import BaseImage from "Public/components/BaseImage";

export default {
  name: "SideNavLogo",
  components: { BaseImage },
  props: {
    customLogo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    url: {
      type: String,
      default: `${STATIC_IMG_PATH}/logo.svg`,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~PublicStyles/_variables.scss";
.sidenav-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-bottom: 1px solid #ebebeb;
  padding: 0 48px 0 26px;

  @media ($tablet) {
    display: none;
  }

  img {
    padding: 0;
    width: auto;
    height: auto;
    max-height: 60px;
    display: block;
  }
}
</style>
